import { NetworkViewV2Page } from "fleet/view/network/view-v2";
import { connect } from "react-redux";
import { isStoreReady } from "redux-store";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { getAuthUser } from "redux-store/auth/selectors";
import { DELETE_NETWORK } from "redux-store/networks/actions";
import { networksSelector } from "redux-store/networks/selectors";

function mapStateToProps(state, props) {
  const { id } = props.match.params || {};
  const storesLoaded = isStoreReady(state.global.networks);

  return {
    user: getAuthUser(state),
    network: networksSelector(state)[id],
    storesLoaded,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    deleteNetwork: (networkId) => {
      return createPromiseApiAction(dispatch, DELETE_NETWORK, [networkId]);
    },
  };
}

const ConnectedNetworkViewV2Page = connect(
  mapStateToProps,
  mapDispatchToProps,
)(NetworkViewV2Page);

export { ConnectedNetworkViewV2Page };
